<template>
	<div>
		<section
			data-stellar-background-ratio="0.3"
			style="background-image: url(/assets/img/camps.jpg); padding: 120px 0px"
			class="page-title-parallax page-title-dark"
			id="page-title"
		>
			<div class="container clearfix">
				<h1 data-animate="fadeInUp">Classes</h1>
				<span data-delay="300" data-animate="fadeInUp"
					>Ballet - Jazz - Hip Hop - Acro - Contemporary - Ballroom</span
				>
			</div>
		</section>
		<section id="content">
			<div class="content-wrap">
				<div class="container clearfix">
					<div class="col_one_third bottommargin-sm center">
						<img data-animate="fadeInLeft" src="/assets/img/ballet.jpg" alt="Ballet Classes" />
					</div>
					<div class="col_two_third bottommargin-lg col_last">
						<div class="heading-block topmargin-sm">
							<h3>Ballet</h3>
							<span>From Baby Ballet to Ballet 5 Level</span>
						</div>

						<p>
							Our methodology is founded from the Cuban School of Ballet, complemented with methodologies from other
							national and international dance companies.
						</p>

						<p>
							Our school has developed a comprehensive syllabus to implement in each level based on the child's capacity
							and abilities.
						</p>

						<a
							href="/#/contact"
							class="button button-border button-dark button-rounded button-large noleftmargin topmargin-sm"
							>Learn more</a
						>
					</div>

					<div class="line"></div>

					<div class="col_two_third bottommargin-sm col_last">
						<div class="heading-block topmargin-sm">
							<h3>Jazz</h3>
							<span>Levels 1 - 3</span>
						</div>

						<p>
							Jazz is a style of dance performed to modern rhythms which has been developed from ballet, jazz music and
							African American rhythms.
						</p>
						<p>Technique is the foundation of all dance movements including jumps, turns, and extensions.</p>

						<a
							href="/#/contact"
							class="button button-border button-dark button-rounded button-large noleftmargin topmargin-sm"
							>Learn more</a
						>
					</div>
					<div class="col_one_third bottommargin-lg center align-right">
						<img data-animate="fadeInRight" src="/assets/img/jazz.jpg" alt="Jazz Classes" />
					</div>

					<div class="col_one_third bottommargin-sm center">
						<img data-animate="fadeInLeft" src="/assets/img/hip-hop.jpg" alt="Hip Hop Classes" />
					</div>
					<div class="col_two_third bottommargin-lg col_last">
						<div class="heading-block topmargin-sm">
							<h3>Hip Hop</h3>
						</div>

						<p>
							This style differs from other forms of dance is that it is often "freestyle" (improvisational) in nature.
							Hip-hop is highly musical and is just as phisically demanding as any other style.
						</p>
						<a
							href="/#/contact"
							class="button button-border button-dark button-rounded button-large noleftmargin topmargin-sm"
							>Learn more</a
						>
					</div>

					<div class="line"></div>

					<div class="col_two_third bottommargin-sm col_last">
						<div class="heading-block topmargin-sm">
							<h3>Acro</h3>
						</div>

						<p>
							Acro dance is a style of dance that combines classical dance technique with precision acrobatic elements.
							It is defined by the athletic character, its unique choreography, which seamlessly blends dance into
							acrobatic, and its use of acrobatic in a dance context.
						</p>
						<p>
							Acro dance is known by various other names including acrobatic dance and gymnastic dance, though it is
							most commonly referred to simply as acro by dancers and dance professionals. Acro is an especially
							challenging dance style for dancers as it requires them to be trained in both dance and acrobatic skills.
							Acro dancers must be in excellent physical condition as well, because acro is a physically demanding
							activity.
						</p>

						<a
							href="/#/contact"
							class="button button-border button-dark button-rounded button-large noleftmargin topmargin-sm"
							>Learn more</a
						>
					</div>
					<div class="col_one_third bottommargin-lg center align-right">
						<img data-animate="fadeInRight" src="/assets/img/acro.jpg" alt="Acro Classes" />
					</div>

					<div class="line"></div>

					<div class="col_one_third bottommargin-sm center">
						<img data-animate="fadeInLeft" src="/assets/img/contemporary.jpg" alt="Contemporary Classes " />
					</div>
					<div class="col_two_third bottommargin-lg col_last">
						<div class="heading-block topmargin-sm">
							<h3>Contemporary / Lyrical</h3>
						</div>

						<p>
							Contemporary dance is a style of expressive dance that combines elements of several dance genres including
							modern, jazz, lyrical and classical ballet.
						</p>
						<p>
							During this class dancers strive to connect the mind and the body through fluid dance movements. Students
							will develop versatility and improvisation, during complex combinations. This dance genre is often done in
							bare feet.
						</p>
						<a
							href="/#/contact"
							class="button button-border button-dark button-rounded button-large noleftmargin topmargin-sm"
							>Learn more</a
						>
					</div>

					<div class="line"></div>

					<div class="col_two_third bottommargin-sm col_last">
						<div class="heading-block topmargin-sm">
							<h3>Ballroom</h3>
							<span>Level 1- 2 </span>
						</div>

						<p>
							Our Ballroom classes are structured in a way that dancers are allowed to explore a variety of rhythms with
							each of their own step-patterns and movements. Known for being highly energetic a dance discipline,
							ballroom reflects the syncopated rhythm of the music being danced to.
						</p>
						<p>
							Some of the rhythms our dancers learn are Swing, Rumba/Bolero, Cha Cha, Salsa/Mambo, Merengue,
							Disco/Hustle, Samba and Paso Doble.
						</p>

						<a
							href="/#/contact"
							class="button button-border button-dark button-rounded button-large noleftmargin topmargin-sm"
							>Learn more</a
						>
					</div>
					<div class="col_one_third bottommargin-lg center align-right">
						<img data-animate="fadeInRight" src="/assets/img/ballroom.jpg" alt="Ballroom Classes" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	name: 'Classes',
	components: {},
}
</script>
